import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=cdea4874"
import script from "./ModuleCard.vue?vue&type=script&lang=ts"
export * from "./ModuleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports